import { render, staticRenderFns } from "./PackageFeaturesUsersForm.vue?vue&type=template&id=275f8ebb&"
import script from "./PackageFeaturesUsersForm.vue?vue&type=script&lang=js&"
export * from "./PackageFeaturesUsersForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports